declare let Foo;
export default window;